<div class="email-welcome">
    <div class="email-welcome__content" *ngIf="!loading && !error">
        <h1 class="email-welcome__title">Вітаємо в сім'ї<br>Friends of Fashion</h1>
        <p class="email-welcome__email">{{email}}</p>
    </div>

    <div class="email-welcome__content" *ngIf="loading">
        <p class="email-welcome__loading">Завантаження...</p>
    </div>

    <div class="email-welcome__content" *ngIf="!loading && error">
        <p class="email-welcome__error">Невалідне або застаріле посилання.</p>
    </div>
</div>
